// extracted by mini-css-extract-plugin
export default {"topPart":"yrCDHx","texts":"eEsPb_","subTitle":"NcjOvO","searchAgain":"WH9ksA","categories":"fjHC36"};